<!--
  V 0.3.0 - 2024-12-18
      - Removed start and stop address
  v 0.2.0 -  2024-05-21
      - updated the layout of the map cards.

  V 0.1.0 - 2022-09-07

-->
<template>
  <v-card>
    <v-card :color="trip.ViolationAllCount > 0 ? 'red' : 'green'" dark>
      <v-card-title class="text-h6">
        Trip:
        <v-divider class="mx-4" vertical></v-divider>

        {{ friendlyTime(trip.StartTime) }}
        <v-divider class="mx-4" vertical></v-divider>

        {{ friendlyTime(trip.EndTime) }}

        <v-divider class="mx-4" vertical></v-divider>

        <v-spacer></v-spacer>

        <!--
  <v-btn
         :to="`/trip-plot/${trip.Id}/${trip.UnitID}/${VehicleReg}/calendar-trips-select/${selectedEvent.dayDate}/${VehicleID}`"
         class="mx-0"
         outlined>
    Trip
  </v-btn>
    -->

      </v-card-title>

      <v-list light>
 <!-- // 2024-12-18
     <v-list-item>
        <v-list-item-action>
            <v-icon>mdi-checkbox-blank-circle-outline</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ trip.StartPositionName }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-list-item-action>
        </v-list-item>

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ trip.EndPositionName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
 -->

        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-speedometer</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title
              >(avg) {{ trip.SpeedAverage }} km/h</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-divider inset></v-divider>
      </v-list>
    </v-card>

    <v-card height="360px">
      <MapCard :Id="trip.Id"> </MapCard>
    </v-card>
  </v-card>
</template>
<script>
import { format, parseISO } from 'date-fns'
import MapCard from './MapCard'

export default {
  components: {
    MapCard
  },
  props: {
    VehicleReg: {
      defualt: '',
      type: String
    },
    trip: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      //
    }
  },
  methods: {
    friendlyTime (dateString) {
      if (typeof dateString === 'undefined') {
        return null
      }
      dateString = dateString.split('.')[0]

      return format(parseISO(new Date(dateString).toISOString()), 'hh:mm')
    },

    friendlyDate (dateString) {
      if (typeof dateString === 'undefined') {
        return null
      }
      dateString = dateString.split('.')[0]
      return format(
        parseISO(new Date(dateString).toISOString()),
        'EEEE, MMMM do yyyy hh:mm'
      )
    },
    dayDate (dateString) {
      if (typeof dateString === 'undefined') {
        return null
      }
      dateString = dateString.split('.')[0]
      return format(parseISO(new Date(dateString).toISOString()), 'yyyy-MM-dd')
    }
  }
}
</script>
